import { Message } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import artifactValidationStatuses from "astrid-firestore/src/api/artifacts/constants/artifactValidationStatuses";

import Flex from "../../../../components/Flex/Flex";

import ArtifactValidationStatusLabel from "../ArtifactStatus/ArtifactValidationStatusLabel";

function getMessage({ t, artifact }) {
	switch (artifact?.status) {
		case artifactValidationStatuses.PENDING:
		case artifactValidationStatuses.VALIDATING:
			return `${t(
				"currentlyValidatingArtifact",
				"The artifact is currently validating. Please wait until the validation is completed",
			)}...`;
		case artifactValidationStatuses.FAILED:
		case artifactValidationStatuses.INVALID:
			return t("artifactValidationFailed", "The artifact is not valid. Please check the artifact files.");
		default:
			return "";
	}
}

export default function ArtifactValidatingMessage({ artifact }) {
	const { t } = useTranslation();
	return (
		<Message
			info
			content={
				<Flex>
					<i>{getMessage({ t, artifact })}</i>
					<div>
						<ArtifactValidationStatusLabel artifact={artifact} />
					</div>
				</Flex>
			}
		/>
	);
}
